import axios from "axios";
import Cookies from "universal-cookie";

const cookie = new Cookies();

export const auth = () => {
  const token = cookie.get("hts-tok");
  const instance = axios.create({
    baseURL: "https://bapi.logistx.us",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return instance;
};

export const noAuth = () => {
  const instance = axios.create({
    baseURL: "https://bapi.logistx.it",
    headers: {
      "Content-type": "application/json",
    },
  });
  return instance;
};
